const DEFAULT_API_BASE_URL =
  'https://maaliondoor-backend-prod-6573o6ksgq-ew.a.run.app'

const runtimeApiBaseUrl =
  typeof window === 'undefined' ? undefined : window.__RUNTIME_CONFIG__?.API_BASE_URL

export const API_BASE_URL = (
  runtimeApiBaseUrl ??
  import.meta.env.VITE_API_BASE_URL ??
  DEFAULT_API_BASE_URL
).replace(/\/$/, '')

export const HTTP_STATUS = {
  unauthorized: 401,
} as const

export const HTTP_METHOD = {
  get: 'GET',
  post: 'POST',
  patch: 'PATCH',
  delete: 'DELETE',
} as const

export const API_ROUTES = {
  authLogin: '/auth/login',
  authRefresh: '/auth/refresh',
  authLogout: '/auth/logout',
  authMe: '/auth/me',
  vendor: (id: string) => `/vendors/${id}`,
  locationSearch: '/locations/search',
  vendorProducts: '/vendor-products',
  vendorProduct: (id: string) => `/vendor-products/${id}`,
  products: '/products',
  orders: '/orders',
  order: (id: string) => `/orders/${id}`,
  notifications: '/notifications',
  notificationsUnread: '/notifications/unread-count',
  notificationsStream: '/notifications/stream',
  notificationsReadAll: '/notifications/read-all',
  notificationRead: (id: string) => `/notifications/${id}/read`,
} as const
